export default __webpack_public_path__ + "static/media/home-page-background.c31cd22c.png";